import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const TurboDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}>Cazan pe peleți <span className={styles.highlight}>Duo Uni Pellet</span></p>
      <p className={styles.text}>
        Aceste cazane cu ardere îndelungată sunt destinate încălzirii spatiilor de producție mici, pensiunilor și caselor .
      </p>
      <p className={styles.text}>
        Schimbătorul de căldură este realizat sub formă de rafturi din țevi fără sudură. Dimensiunile mari ale schimbătorului de căldură asigură un transfer maxim de căldură. Sistemul de alimentare cu aer multi-canal și dispunerea simetrică a conductelor de aer asigură o combustie uniformă și eficientă a combustibilului. Designul unic al cazanului permite ajustarea randamentului declarat cu un consum destul de mic de combustibil.
      </p>
      <p className={styles.text}>
        Combustibilul este încărcat manual. Ușa înclinată face această procedură mai comoda. Este posibil să instalați un arzător cu peleți, ceea ce va permite furnizarea de combustibil fracționat în regim automat.
      </p>
      <p className={styles.text}>
        Procesul de ardere este controlat de unitatea de control PID.
      </p>
      <div className={styles.tableContainer}>
        <div className={styles.tableContainer}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Parametri</th>
                <th>U.M.</th>
                <th>15 kW</th>
                <th>20 kW</th>
                <th>35 kW</th>
                <th>50 kW</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Suprafața schimbătorului de căldură</td>
                <td>m²</td>
                <td>1,8</td>
                <td>2,4</td>
                <td>3,3</td>
                <td>4,4</td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <th colSpan="6">Dimensiuni camera de ardere</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Volum</td>
                <td>dm³</td>
                <td>134</td>
                <td>206</td>
                <td>385</td>
                <td>617</td>
              </tr>
              <tr>
                <td>Volumul apei din cazan</td>
                <td>l</td>
                <td>49</td>
                <td>66</td>
                <td>92</td>
                <td>131</td>
              </tr>
              <tr>
                <td>Greutate cazan fără apă</td>
                <td>kg</td>
                <td>215</td>
                <td>250</td>
                <td>335</td>
                <td>490</td>
              </tr>
              <tr>
                <td>Temperatura gazelor arse</td>
                <td>°C</td>
                <td colSpan="4">100 - 180</td>
              </tr>
              <tr>
                <td>Temperatura min. recomandată</td>
                <td>°C</td>
                <td colSpan="4">58</td>
              </tr>
              <tr>
                <td>Temperatura max. permisă a apei din cazan</td>
                <td>°C</td>
                <td colSpan="4">85</td>
              </tr>
              <tr>
                <td>Presiunea nominală a apei</td>
                <td>mPa</td>
                <td colSpan="4">0,15</td>
              </tr>
              <tr>
                <td>Consum energie electrică, max</td>
                <td>W</td>
                <td>85</td>
                <td>85</td>
                <td>105</td>
                <td>160</td>
              </tr>
              <tr>
                <td>Diametrul ext al gurii de evacuare</td>
                <td>mm</td>
                <td>159</td>
                <td>159</td>
                <td>178</td>
                <td>219</td>
              </tr>
              <tr>
                <td>Diametrul țevilor conexiune rețea apa</td>
                <td>mm</td>
                <td>40</td>
                <td>40</td>
                <td>50</td>
                <td>50</td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <th colSpan="6">Parametri recomandați burlan</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Secțiunea transversală</td>
                <td>cm²</td>
                <td>200</td>
                <td>200</td>
                <td>248</td>
                <td>377</td>
              </tr>
              <tr>
                <td>Diametrul intern</td>
                <td>mm</td>
                <td>160</td>
                <td>160</td>
                <td>180</td>
                <td>220</td>
              </tr>
              <tr>
                <td>Înălțime (min. recomandată)</td>
                <td>m</td>
                <td>5</td>
                <td>5</td>
                <td>6</td>
                <td>6</td>
              </tr>
              <tr>
                <td>Diametru țevii de sub sigurantele supapei</td>
                <td>mm</td>
                <td>15</td>
                <td>15</td>
                <td>15</td>
                <td>20</td>
              </tr>
              <tr>
                <td>Diametrul țevii de scurgere a apei din cazan</td>
                <td>mm</td>
                <td>40</td>
                <td>40</td>
                <td>50</td>
                <td>50</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export const TurboDimensions = () => {
  const data = [
    { param: "B", unit: "mm", values: [795, 795, 970, 1120] },
    { param: "D", unit: "mm", values: [570, 570, 730, 890] },
    { param: "H", unit: "mm", values: [1690, 2160, 2190, 2190] },
    { param: "H1", unit: "mm", values: [1490, 1960, 1960, 1960] },
    { param: "H2", unit: "mm", values: [1416, 1886, 1886, 1886] },
    { param: "H3", unit: "mm", values: [1186, 1656, 1656, 1656] },
    { param: "H4", unit: "mm", values: [146, 146, 146, 146] },
    { param: "L1", unit: "mm", values: [795, 795, 960, 1120] }
  ]


  const headers = ["Parametri", "U.M.", "15 kW", "20 kW", "35 kW", "50 kW"]

  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/TurboSchema.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <div className={styles.tableContainer}>
          <table className={styles.table}>
            <thead>
              <tr>
                {headers.map((header, index) => (
                  <th key={index}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td>{row.param}</td>
                  <td>{row.unit}</td>
                  {row.values.map((value, valueIndex) => (
                    <td key={valueIndex}>{value}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};